import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import useAuth from "../hooks/useAuth";

const page1Points = [
  {
    title: "1. Services Performed By Surveyor.",
    content: `Surveyor agrees to perform the a survey of the property set forth in item 3, and item 18 and incorporated herein by this reference ("services").`,
  },
  {
    title: "2. Compensation By Client.",
    content: `Client agrees to compensate Surveyor for said services according to the estimate provided in Item 3 and incorporated herein by this reference ("schedule") and agrees to provide payment according to this entire 3 page agreement.`,
  },
  {
    title: "3. Property.",
    content: `The property upon which the services hereinafter described are to be performed is located at`,
  },
];
const page2Points = [
  {
    title: "4. Documents Provided By Client.",
    content: `Client agrees to provide Surveyor with any and all documents necessary to identify the ownership, location and condition of the property to be surveyed, including, but not limited to, deeds, maps, title information, and permits; and to obtain for Surveyor the authorization of the owner to enter upon the property for the purpose of conducting Surveyor's work thereon.`,
  },
  {
    title: "5. Ownership of Work Product.",
    content: `Client acknowledges that all original papers, documents, maps, surveys, and other work product of Surveyor, and copies thereof, produced by Surveyor pursuant to this Agreement, except documents which are required to be filed with public agencies, shall remain the property of Surveyor and the Surveyor has the unrestricted right to use any such work product for any purpose whatsoever without the consent of Client. Client further acknowledges that Client's right to utilize the services and work product performed pursuant to this Agreement will continue only so long as Client is not in default pursuant to the terms and conditions of this Agreement and Client has performed all obligations under this Agreement.`,
  },
  {
    title: "6. Use of Work Product.",
    content: `Client agrees not to use or permit any other person to use maps, exhibits, legal descriptions, surveys, or other work product ("work product") prepared by Surveyor, except for the following purpose:`,
  },
];
const page3Points = [
  {
    title: "7. Copyright.",
    content: `The parties agree that all protections of the
    United States and Texas copyright laws shall be applicable to the work
    product to the benefit of Surveyor, including common law and statutory
    law, whether or not such work product actually is so copyrighted, and
    without regard to whether or not such copyright actually applies to such
    work product.`,
  },
  {
    title: "8. Billing.",
    content: `All fees and other charges attributable to this Agreement will be billed by Surveyor monthly and shall be due and payable by Client at the time of billing at the address of Surveyor listed below unless otherwise specified in this Agreement.`,
  },
  {
    title: "9. Suspension or Termination of Performance.",
    content: `In addition to any other rights Surveyor may have for default of Client, if Client fails to pay Surveyor within thirty (30) days after invoices are rendered, Client agrees Surveyor shall have the right to consider such default in payment a material breach of this Agreement, and, upon written notice, the duties, obligations, and responsibilities of Surveyor under this Agreement may be suspended or terminated at Surveyor's sole option.`,
  },
  {
    title: "10. Additional Services. ",
    content: `Client agrees that if services not specified in this Agreement are provided at Client's request, Client shall timely pay for all such services as extra work at the rates set forth in Exhibit "C" attached hereto and by this reference incorporated herein.`,
  },
  {
    title: "11. Payment of Costs. ",
    content: `Client shall pay all costs, such as transportation expenses, zoning application fees, blueprint and reproduction costs, aerial topography fees, etc., unless otherwise expressly agreed herein by the parties.`,
  },
  {
    title: "12. Delays.",
    content: `Surveyor is not responsible for delays caused by activities or factors beyond Surveyor's control, including but not limited to, delays caused by strikes, lockouts, work slowdowns or stoppages, accidents, acts of nature, failure of Client to timely furnish information or approve or disapprove Surveyor's work, or faulty performance by Client or others, including contractors and governmental agencies.`,
  },
  {
    title: "13. Attorney's Fees.",
    content: `If Client or Surveyor is a prevailing party in any legal proceeding brought under or with relation to this Agreement, such party shall be entitled to recover from the non-prevailing party all costs of such proceeding and reasonable attorney's fees.`,
  },
  {
    title: "14. Arbitration.",
    content: `All claims, disputes, and other matters in question arising out of or relating to this Agreement shall be submitted to binding arbitration and the parties hereto agree to execute and/or obtain the execution of all documents as may be necessary to submit such matters to arbitration. Unless otherwise agreed by the parties, said arbitration shall be in accordance with the rules and regulations of the American Arbitration Association.`,
  },
  {
    title: "15. Contractual Lien to Secure Payment.",
    content: `Client grants to Surveyor a contractual lien in addition to all constitutional, statutory, and equitable liens that may exist, on the property and all improvements thereon to secure payment of all compensation due Surveyor by Client as provided herein. Client grants Surveyor the authority and right to file a copy of this Agreement in the Records of the County where the property is located to give notice of Surveyor's lien rights.`,
  },
  {
    title: "16. Governing Law. ",
    content: `This Agreement shall be construed and enforced in accordance with the laws of Texas.`,
  },
  {
    title: "17. Entire Agreement of Parties.",
    content: `This contract contains the entire agreement of the parties and cannot be changed except by their written agreement.`,
  },
  /*  {
    title: "18. Special Provisions or requests by Client:",
    content: ``,
  }, */
];
const page4Points = [
  {
    title: "1. Services Performed By Surveyor.",
    content: `Surveyor agrees to perform the survey of the property set forth in the quote herein by this reference ("services").`,
  },
  {
    title: "2. Compensation By Client.",
    content: `Client agrees to compensate Surveyor for said services according to the estimate provided in this quote and agrees to provide`,
  },
  {
    title: "3.",
    content: `Client agrees to obtain for Surveyor the authorization of the owner to enter upon the property for the purpose of conducting Surveyor's work thereon.`,
  },
  {
    title: "4.",
    content: `Client further agrees that the work product prepared by Surveyor may not be altered or reproduced in any way nor used on any other project or for any purpose other than as specifically authorized herein by Surveyor. Surveyor agrees to provide copies of the work product.`,
  },
  {
    title: "5. Suspension or Termination of Performance.",
    content: `In addition to any other rights Surveyor may have for default of Client, if Client fails to pay Surveyor within thirty (30) days after invoices are rendered, Client agrees Surveyor shall have the right to consider such default in payment a material breach of this Agreement, and, upon written notice, the duties, obligations, and responsibilities of Surveyor under this Agreement may be suspended or terminated at Surveyor's sole option.`,
  },
  {
    title: "6. Contractual Lien to Secure Payment.",
    content: `Client grants to Surveyor a contractual lien in addition to all constitutional, statutory, and equitable liens that may exist, on the property and all improvements thereon to secure payment of all compensation due Surveyor by Client as provided herein. Client grants Surveyor the authority and right to file a copy of this Agreement in the Records of the County where the property is located to give notice of Surveyor's lien rights.`,
  },
  {
    title: "7. Governing Law.",
    content: `This Agreement shall be construed and enforced in accordance with the laws of Texas.`,
  },
  {
    title: "8. Entire Agreement of Parties.",
    content: `This contract contains the entire agreement of the parties and cannot be changed except by their written agreement.`,
  },
];

const getAddress = (fields, contract) => {
  return fields
    .map((field) => contract[field])
    .filter((value) => (value ? value.trim() : false))
    .join(" ");
};

const AgreementForm = ({ contract = {} }) => {
  const [activePage, setActivePage] = useState(1);
  const [propertyAddress] = useState(
    getAddress(
      ["propertyAddress", "propertyStreet", "city", "county"],
      contract
    )
  );

  const [clientName] = useState(
    !contract["isClientDifferent"]
      ? `${contract["firstName"]} ${contract["lastName"]}`
      : contract["clientName"]
  );

  const [clientEmail] = useState(
    contract["isClientDifferent"] ? contract["clientEmail"] : contract["email"]
  );
  const { user } = useAuth();

  useEffect(() => {
    const mainHeaderElement = document.getElementById("mainHeader");

    if (mainHeaderElement) {
      mainHeaderElement.scrollIntoView({ behavior: "smooth" });
    }
  }, [activePage]);

  const Point = ({ point }) => {
    return (
      <div className="mb-2">
        <b>{point.title}</b> {point.content}
        <br />
      </div>
    );
  };

  const QA = ({ q, a, isDate = false }) => {
    return (
      <p className="mb-1">
        <b>{q}: </b>
        {a ? (isDate ? moment(a).format("MMMM Do YYYY") : a) : "N/A"}
      </p>
    );
  };

  const Page1 = () => {
    return (
      <>
        <p>
          This agreement is made and entered into between ATM Surveying – Adam
          Wallace, President (Surveyor) and <b>{clientName}</b>
          (Client) effective this day,
          <b>
            {moment(
              contract["contractDate"] ? contract["contractDate"] : new Date()
            ).format("MMMM Do YYYY")}
          </b>
          .
        </p>

        <p>Client and Surveyor agree as follows:</p>
        {page1Points.map((p) => (
          <Point point={p} />
        ))}

        <QA q={"Address"} a={propertyAddress} />
        <QA
          q={"Survey Estimate (based on information provided)"}
          a={`${contract["value"]} + tax `}
        />
        <QA
          q={"Date Survey needs to be complete"}
          a={contract["agreedDueDate"]}
          isDate
        />
        <QA q={"Title Closing Date"} a={contract["titleClosingDate"]} isDate />
        <QA
          q={`County Appraisal District Property ID and description ("the property")`}
          a={contract["propertyAppraisalId"]}
        />
        <hr />
        <b>Client – Responsible for Payment</b>
        <br />
        <Row className="mt-2">
          <Col>
            <QA q={`Client`} a={clientName} />
          </Col>
          <Col>
            <QA q={`Referred by`} a={contract["companyReferrerName"]} />
          </Col>
          <Col>
            <QA q={`Email`} a={clientEmail} />
          </Col>
        </Row>
        <QA q={`Driver’s License #`} a={contract["driversLicense"]} />
        <QA q={`Address`} a={propertyAddress} />
        <Row>
          <Col>
            <QA q={`City`} a={contract["city"]} />
          </Col>
          <Col>
            <QA q={`State`} a={"TX"} />
          </Col>
        </Row>
        {/*  <Row className="mt-3">
          <Col>
            <QA q={`Signature`} a={contract["Signature"]} />
          </Col>
          <Col>
            <QA q={`Date`} a={contract["Date"]} />
          </Col>
        </Row>
        <p className="mb-3">
          By signing this document, I agree that the above information is my
          contact information, and that I agree to the above estimate, and to
          all terms specified in this document.
        </p> */}
        <hr />
        <QA q={"Surveyor"} a={"ATM surveying"} />
        <QA q={"By"} a={"Adam Wallace, President"} />
        <QA q={"Address"} a={"750 William D Fitch, Suite 230 #201"} />
        <Row>
          <Col>
            <QA q={"City"} a={"College Station"} />
          </Col>
          <Col>
            <QA q={"State"} a={"TX"} />
          </Col>
        </Row>
        <QA q={"Telephone"} a={"(979) 209-9291"} />
        <QA q={"Email"} a={"adam@aTmSurveying.com"} />

        {/*  <Row className="my-2">
          <Col>
            <QA q={`Signature`} a={contract["Signature"]} />
          </Col>
          <Col>
            <QA q={`Date`} a={contract["Date"]} />
          </Col>
        </Row> */}
      </>
    );
  };

  const Page2 = () => {
    return (
      <>
        <p>
          Are there any items that need to be prepared on the property before
          field crews arrival like the following:
        </p>
        <ul>
          {[
            "Dogs that need to be put up?",
            "Gates that need to be unlocked to get access to the backyard?",
            "Construction crews that need to park out of the way?",
            "Construction materials that need to be moved out of the way property lines or permanent items?",
            "Any snakes, spiders, wasps nests, boars, or any other potential dangers around the property?",
          ].map((t) => (
            <li>{t}</li>
          ))}
        </ul>

        {page2Points.map((p) => (
          <Point point={p} />
        ))}
      </>
    );
  };

  const Page3 = () => {
    return (
      <>
        <p>
          Client further agrees that the work product prepared by Surveyor may
          not be altered or reproduced in any way nor used on any other project
          or for any purpose other than as specifically authorized herein by
          Surveyor. Surveyor agrees to provide copies of the work product
          enumerated below to Client as follows:
        </p>
        <p>
          <u>
            Digitally signed and sealed copies to be sent to the title company
            for collection of invoiced amount, unless otherwise agreed upon.
          </u>
        </p>
        {page3Points.map((p) => (
          <Point point={p} />
        ))}
        {/* {contract["specialProvision"] || "To be filled (specialProvision)"} */}
      </>
    );
  };

  const Page4 = () => {
    return (
      <>
        <p>Client and Surveyor agree as follows:</p>

        {page4Points.map((p) => (
          <Point point={p} />
        ))}

        <p className="mt-5">
          By clicking to accept this document, I agree that the above
          information is my contact information, and that I agree to the above
          estimate, and to all terms specified in this document.
        </p>
      </>
    );
  };

  return (
    <>
      <h5 id="header" className="text-center">
        AGREEMENT FOR PROFESSIONAL LAND SURVEYING SERVICES
      </h5>
      {user?.email && (
        <h6 className="text-muted text-center">
          ({contract["contractStatus"]})
        </h6>
      )}
      <div style={{ fontSize: 14 }} className="my-2 border rounded p-md-4 p-2">
        <Page1 />
        <Page2 />
        <Page3 />
        <Page4 />

        <hr className="my-2" />
        <i>
          If you have any queries or issues, you can mail us at{" "}
          <a
            href={`mailto:adam@aTmSurveying.com?subject=Regarding ${contract["propertyAddress"]}`}
          >
            adam@aTmSurveying.com
          </a>
        </i>
      </div>
    </>
  );
};

export default AgreementForm;
